import { useNavigate } from "react-router-dom";
import "react-datepicker/dist/react-datepicker.css";
import { getAllCategories, getAllBrands } from "../../reduxSaga/actions";
import { Alert, Snackbar } from "@mui/material";

import { useSelector, useDispatch } from "react-redux";
import AddCategory from "../../ui/AddCategory";
import { useEffect, useState } from "react";
import Select from "react-select";
import EditCategory from "../../ui/EditCategory";
// import MaterialTable from "material-table";
// import uploadAndDownloadService from "../../services/uploadAndDownloadFile";
import getCurrentUserId from "../../reduxSaga/sagas/requests/currentUserId";
import ProductService from "../../services/ProductService";
import DataTableProducts from "../../ui/DataTableProducts";
const ProductsCategory = () => {
  const dispatch = useDispatch();
  const availableCategories = useSelector(
    (state) => state.staff.availableCategories
  );
  const availableBrands = useSelector((state) => state.staff.availableBrands);
  // const availableProducts = useSelector(
  //   (state) => state.staff.availableProducts
  // );
  // const archivedProducts = useSelector((state) => state.staff.archivedProducts);
  const [listProduits, setListProduits] = useState([]);
  const [openInfoAlert, setOpenInfoAlert] = useState(false);
  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [errorAlertText, setErrorAlertText] = useState();
  const [oldCategoryData, setOldCategoryData] = useState();
  const [startDate, setStartDate] = useState("any");
  const [endDate, setEndDate] = useState("any");
  const categoryOptions = [
    { value: 0, label: "Toutes les catégories" },
    ...(availableCategories || []).map((element) => ({
      value: element.id,
      label: `${element.productFamilyName}-${element.productSubFamilyName}-${element.name}`,
    })),
  ];
  const brandOptions = [
    { value: 0, label: "Toutes les marques" },
    ...(availableBrands || []).map((element) => ({
      value: element.id,
      label: element.name,
    })),
  ];
  const [categoryId, setCategoryId] = useState(0);
  const [brandId, setBrandId] = useState(0);
  const [productStatus, setProductStatus] = useState("dispo");
  // const [srcValue, setSrcValue] = useState("");
  // const [newPath, setNewPath] = useState("");
  // const [productBarCode, setProductBarCode] = useState("");
  const [productCodeArticle, setProductCodeArticle] = useState("none");
  const [infoAlertText, setInfoAlertText] = useState();

  const [onAddCategory, setOnAddCategory] = useState(false);
  const [onEditCategory, setOnEditCategory] = useState(false);
  // const [availableImage, setAvailableImage] = useState([]);
  // const [archivedImage, setArchivedImage] = useState([]);
  const [showElement, setShowElement] = useState([]);
  const [showTable, setShowTable] = useState(false);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalElements, setTotalElements] = useState(0);
  const [appliedFilters, setAppliedFilters] = useState({
    isDeleted: 0,
    brandId: 0,
    categoryId: 0,
    dateDebut: "",
    dateFin: "",
    productCode: "",
  });

  const navigate = useNavigate();
  // const imagesRefs = useRef([]);
  // const archivedimagesRefs = useRef([]);

  useEffect(() => {
    dispatch(getAllCategories(0));
    dispatch(getAllBrands(0));
  }, []);

  useEffect(() => {
    // let user = JSON.parse(localStorage.getItem("user"));
    if (localStorage.getItem("status") == null) {
      setShowElement(["notConnected"]);
    } else {
      setShowElement(JSON.parse(localStorage.getItem("status")));
    }
  }, []);
  const handleInfoClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenInfoAlert(false);
  };

  useEffect(() => {
    if (startDate === ":59") {
      setStartDate("any");
    }
    if (endDate === ":59") {
      setEndDate("any");
    }
  }, [startDate, endDate]);

  const onAddCategoryHandler = () => {
    navigate(`/addProduct`);
  };

  const fetchProducts = (pageToLoad, sizeToLoad, filters = appliedFilters) => {
    setLoading(true);
    ProductService.getProductsPage(getCurrentUserId(), {
      page: pageToLoad - 1,
      size: sizeToLoad,
      isDeleted: filters.isDeleted,
      brandId: filters.brandId,
      categoryId: filters.categoryId,
      dateDebut: filters.dateDebut,
      dateFin: filters.dateFin,
      productCode: filters.productCode,
    })
      .then((result) => {
        const data = result.data;
        if (data.error) {
          setErrorAlertText("Erreur lors du chargement des produits");
          setOpenErrorAlert(true);
          return;
        }
        const pageData = data.success;
        setListProduits(pageData.content);
        setTotalElements(pageData.totalElements);
        setPage(pageToLoad);
        setPageSize(sizeToLoad);
        setShowTable(true);
      })
      .catch(() => {
        setErrorAlertText("Erreur lors du chargement des produits");
        setOpenErrorAlert(true);
      })
      .finally(() => setLoading(false));
  };

  const onGetProductsByFilter = () => {
    const filters = {
      isDeleted: productStatus === "dispo" ? 0 : 1,
      brandId: brandId,
      categoryId: categoryId,
      dateDebut: startDate === "any" ? "" : startDate,
      dateFin: endDate === "any" ? "" : endDate,
      productCode: productCodeArticle === "none" ? "" : productCodeArticle,
    };
    setAppliedFilters(filters);
    fetchProducts(1, pageSize, filters);
  };

  // useEffect(() => {
  //   fetchProducts(1, pageSize);
  // }, []);

  // const onChangeStartDate = (event) => {
  //   setStartDate(event.target.value.concat(":59"));
  // };
  // const onChangeEndDate = (event) => {
  //   setEndDate(event.target.value.concat(":59"));
  // };
  const onChangeStartDate = (event) => {
    const selectedValue = event.target.value;

    // Check if the value already includes a time
    const updatedValue = selectedValue.includes("T")
      ? selectedValue.split(":").slice(0, 2).join(":") + ":00" // Append seconds to time
      : selectedValue + "T00:00:00"; // Add default time with seconds for date input

    setStartDate(updatedValue);
  };
  const onChangeEndDate = (event) => {
    const selectedValue = event.target.value;

    // Check if the value includes a time
    const updatedValue = selectedValue.includes("T")
      ? selectedValue.split("T")[0] + "T23:59:59" // Replace time with the last second of the day
      : selectedValue + "T23:59:59"; // Add default end time with seconds for date input

    setEndDate(updatedValue);
  };

  const filterTableProduct = () => {
    if (showTable) {
      return (
        <DataTableProducts
          listProduits={listProduits}
          remote={{
            page,
            sizePerPage: pageSize,
            totalSize: totalElements,
            onPageChange: (newPage, newSize) =>
              fetchProducts(newPage, newSize),
          }}
        />
      );
    }
  };
  const handleEroorClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorAlert(false);
  };
  const onUploadExcel = () => {
    navigate(`/uploadExcel?type=products`);
  };
  const onResetFilters = () => {
    setProductCodeArticle("none");
    setCategoryId(0);
    setBrandId(0);
    setStartDate("any");
    setEndDate("any");
    setProductStatus("dispo");
    const filters = {
      isDeleted: 0,
      brandId: 0,
      categoryId: 0,
      dateDebut: "",
      dateFin: "",
      productCode: "",
    };
    setAppliedFilters(filters);
    // fetchProducts(1, pageSize, filters);
  };
  const dateToInput = (value) => (value === "any" ? "" : value.split("T")[0]);
  const labelStyle = {
    fontSize: "0.8rem",
    fontWeight: 600,
    textTransform: "uppercase",
    letterSpacing: "0.03em",
    color: "#6c757d",
  };
  const statusBtnClass = (value) =>
    `btn btn-sm ${productStatus === value ? "btn-dark" : "btn-outline-dark"}`;
  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <section className="content-header">
        <div className="container-fluid">
          <div className="d-flex flex-wrap justify-content-between align-items-center">
            <div>
              <h4 className="mb-1">
                <i className="fas fa-boxes mr-2"></i>Produits
              </h4>
              <small className="text-muted">
                Recherchez, consultez et gérez vos produits
              </small>
            </div>
            <div className="mt-2 mt-sm-0">
              <button
                className="btn btn-outline-dark mr-2"
                onClick={onUploadExcel}
              >
                <i className="fas fa-file-excel mr-1"></i>
                Importer un fichier Excel
              </button>
              {!showElement.includes("WAREHOUSE_MANAGER") && (
                <button className="btn btn-dark" onClick={onAddCategoryHandler}>
                  <i className="fas fa-plus mr-1"></i>
                  Ajouter un produit
                </button>
              )}
            </div>
          </div>
        </div>
      </section>

      <div className="content">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-12">
              <div
                className="card card-outline card-dark"
                style={{ borderRadius: 8, boxShadow: "0 1px 6px rgba(0,0,0,.08)" }}
              >
                <div className="card-header">
                  <h3 className="card-title">
                    <i className="fas fa-filter mr-2"></i>Filtres
                  </h3>
                </div>
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-4">
                      <div className="form-group">
                        <label htmlFor="productCode" style={labelStyle}>
                          Code article
                        </label>
                        <input
                          value={
                            productCodeArticle === "none"
                              ? ""
                              : productCodeArticle
                          }
                          onChange={(e) =>
                            setProductCodeArticle(e.target.value || "none")
                          }
                          type="text"
                          id="productCode"
                          placeholder="Saisir un code article"
                          className="form-control"
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label style={labelStyle}>Catégorie</label>
                        <Select
                          isClearable={false}
                          placeholder="Toutes les catégories"
                          noOptionsMessage={() => "Aucun résultat"}
                          options={categoryOptions}
                          value={
                            categoryOptions.find((o) => String(o.value) === String(categoryId)) || null
                          }
                          onChange={(option) => setCategoryId(option ? option.value : 0)}
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label style={labelStyle}>Marque</label>
                        <Select
                          isClearable={false}
                          placeholder="Toutes les marques"
                          noOptionsMessage={() => "Aucun résultat"}
                          options={brandOptions}
                          value={
                            brandOptions.find((o) => String(o.value) === String(brandId)) || null
                          }
                          onChange={(option) => setBrandId(option ? option.value : 0)}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-4">
                      <div className="form-group">
                        <label htmlFor="dateDebut" style={labelStyle}>
                          Date début
                        </label>
                        <input
                          id="dateDebut"
                          type="date"
                          className="form-control"
                          value={dateToInput(startDate)}
                          onChange={onChangeStartDate}
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label htmlFor="dateFin" style={labelStyle}>
                          Date fin
                        </label>
                        <input
                          id="dateFin"
                          type="date"
                          className="form-control"
                          value={dateToInput(endDate)}
                          onChange={onChangeEndDate}
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label style={labelStyle}>État du produit</label>
                        <div className="btn-group d-flex" role="group">
                          <button
                            type="button"
                            className={statusBtnClass("dispo")}
                            style={{ flex: 1 }}
                            onClick={() => setProductStatus("dispo")}
                          >
                            <i className="fas fa-check-circle mr-1"></i>
                            Disponibles
                          </button>
                          <button
                            type="button"
                            className={statusBtnClass("archived")}
                            style={{ flex: 1 }}
                            onClick={() => setProductStatus("archived")}
                          >
                            <i className="fas fa-archive mr-1"></i>
                            Archivés
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card-footer text-right">
                  <button
                    className="btn btn-outline-secondary mr-2"
                    onClick={onResetFilters}
                  >
                    <i className="fas fa-undo mr-1"></i>
                    Réinitialiser
                  </button>
                  <button
                    className="btn btn-dark"
                    onClick={onGetProductsByFilter}
                    disabled={loading}
                  >
                    {loading ? (
                      <>
                        <span
                          className="spinner-border spinner-border-sm mr-2"
                          role="status"
                          aria-hidden="true"
                        ></span>
                        Chargement...
                      </>
                    ) : (
                      <>
                        <i className="fas fa-search mr-1"></i>
                        Valider le choix
                      </>
                    )}
                  </button>
                </div>
              </div>

              {filterTableProduct()}
            </div>
          </div>
        </div>
      </div>
      {openErrorAlert && (
        <Snackbar
          open={openErrorAlert}
          autoHideDuration={2000}
          onClose={handleEroorClose}
          anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        >
          <Alert variant="filled" onClose={handleEroorClose} severity="error">
            {errorAlertText}
          </Alert>
        </Snackbar>
      )}
      {openInfoAlert && (
        <Snackbar
          open={openInfoAlert}
          autoHideDuration={2000}
          onClose={handleInfoClose}
          anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        >
          <Alert variant="filled" onClose={handleInfoClose} severity="info">
            {infoAlertText}
          </Alert>
        </Snackbar>
      )}
      {onAddCategory && <AddCategory setOnAddCategory={setOnAddCategory} />}
      {onEditCategory && (
        <EditCategory
          setOnEditCategory={setOnEditCategory}
          oldCategoryData={oldCategoryData}
        />
      )}
    </div>
  );
};
export default ProductsCategory;
